import React from 'react';
import { FormattedDate, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import DayPicker from '../DatePicker';
import Header from '../Header';
import Button from '../Button';
import InteractivePopup from '../InteractivePopup';
import './styles.css';

class CalendarToolbarAgenda extends React.PureComponent {
  static propTypes = {
    onDayClick: PropTypes.func.isRequired,
    setFromToRange: PropTypes.func.isRequired,
    currentDate: PropTypes.instanceOf(Date).isRequired,
    lastDate: PropTypes.instanceOf(Date).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      firstDayOpen: false,
      lastDayOpen: false,
    };
  }

  openFirstDayPicker = () => this.setState({ firstDayOpen: true });

  openLastDayPicker = () => this.setState({ lastDayOpen: true });

  closeFirstDayPicker = () => this.setState({ firstDayOpen: false });

  closeLastDayPicker = () => this.setState({ lastDayOpen: false });

  handleFirstDayClick = (day) => {
    this.setState({ firstDayOpen: false });
    this.props.onDayClick(day);
    this.props.setFromToRange(day, this.props.lastDate);
  };

  handleLastDayClick = (day, { disabled }) => {
    /* istanbul ignore else */
    if (!disabled) {
      this.setState({ lastDayOpen: false });
      this.props.setFromToRange(this.props.currentDate, day);
    }
  };

  render() {
    const { currentDate: firstDay, lastDate: lastDay } = this.props;
    const { firstDayOpen, lastDayOpen } = this.state;

    return (
      <div styleName="date-range-container">
        <Header as="h2" size="medium" styleName="section-title">
          Agenda
        </Header>
        <InteractivePopup
          styleName="options"
          trigger={(
            <Button styleName="options" size="tiny" data-cy="calendar-agenda-navbar-firstdate">
              <b>
                <FormattedDate
                  value={firstDay}
                  month="2-digit"
                  day="numeric"
                  year="numeric"
                />
              </b><Icon styleName="calendar" name="calendar outline" link color="grey" />
            </Button>
)}
          on="click"
          open={firstDayOpen}
          onOpen={this.openFirstDayPicker}
          onClose={this.closeFirstDayPicker}
        >
          <DayPicker
            selectedDays={firstDay}
            onDayClick={this.handleFirstDayClick}
            month={firstDay}
            disabledDays={[{ after: lastDay }]}
          />
        </InteractivePopup>
        <b styleName="options"> - </b>
        <InteractivePopup
          styleName="options"
          trigger={(
            <Button styleName="options" size="tiny" data-cy="calendar-agenda-navbar-seconddate">
              <b>
                <FormattedDate
                  value={lastDay}
                  month="2-digit"
                  day="numeric"
                  year="numeric"
                />
              </b><Icon styleName="calendar" name="calendar outline" link color="grey" />
            </Button>
)}
          on="click"
          open={lastDayOpen}
          onOpen={this.openLastDayPicker}
          onClose={this.closeLastDayPicker}
        >
          <DayPicker
            selectedDays={lastDay}
            onDayClick={this.handleLastDayClick}
            initialMonth={lastDay}
            disabledDays={[{ before: firstDay }]}
          />
        </InteractivePopup>
      </div>
    );
  }
}

export default injectIntl(CalendarToolbarAgenda);
